export default __webpack_public_path__ + "static/media/application.ac95aeed.png";